<template>
  <div class="verifyName">
    <z-fix-top
      keep-position
      class="fixtop"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          title="实名验证"
          @click-left="closePage"
      >
      </z-nav-bar>
    </z-fix-top>
    <section v-show="!result" class="content">
      <div class="currentname">
        请输入{{ name }} 本人证件号码进行验证：
      </div>
      <z-field
          v-if="['0','1'].includes(cardType)"
          use-number-keyboard
          v-model="idCard"
          placeholder="请输入证件号码"
          maxlength="18"
          @focus="showNumberKeyboard = true"
          @blur="showNumberKeyboard = false"
        />
         <z-field v-else v-model="idCard" maxlength="18" placeholder="请输入证件号码" />
      <z-divider />
      <z-checkbox-group v-model="radio">
        <z-checkbox name="1">
          我已阅读并同意
          <span v-if="isZZ" :style="{ color: '#42A0FF' }" @click.stop="zzagreement">《实人认证服务协议》</span>
          <span :style="{ color: '#42A0FF' }" @click.stop="checkInfo">《个人信息处理授权书》</span>
          <span v-if="isZLJ" :style="{ color: '#42A0FF' }" @click.stop="zljagreement">《找靓机身份识别服务协议》</span>
        </z-checkbox>
      </z-checkbox-group>
      <z-button-group>
        <z-button type="primary" :loading="loading" :disabled="!canSubmit" @click="submit">提交</z-button>
      </z-button-group>
    </section>
    <template v-if="result">
    <div class="real-auth-result">
        <img v-if="isPass == 'true'" :src="successImg" alt="">
        <img v-else :src="failImg" alt="">
        <header>{{ isPass == 'true' ? '恭喜您认证成功' : '很遗憾认证失败'}}</header>
        <div class="desc">{{ copywriting }}</div>
        <div class="operation-area" >
          <div
            v-for="ctx in adapterButtonCtxes(buttonCtxes)"
            :key="ctx.type"
            :class="ctx.style"
          >
            <z-button @click="doCommand(ctx)" size="small-detail" :text="ctx.text"></z-button>
          </div>
        </div>
      </div>
    </template>
    <z-number-keyboard
      close-on-click-overlay
      :show="showNumberKeyboard"
      extra-key="X"
      @input="onInput"
      @delete="onDelete"
    >
    </z-number-keyboard>
  </div>
</template>

<script>
import { NavBar, Button, ButtonGroup, FixTop, Field, Checkbox, CheckboxGroup, Divider, NumberKeyboard } from '@zz-common/zz-ui';
import { getLastCertificationInfo, submitAuthenticationCheck } from '@api/resourceApi'
import { queryParams, getCookie, AESencrypt } from '../../lib/utils'
import native from '@zz-common/native-adapter'

const query = queryParams()
export default {
  name: 'ChangeName',
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-button': Button,
    'z-divider': Divider,
    'z-checkbox-group': CheckboxGroup,
    'z-checkbox': Checkbox,
    'z-button-group': ButtonGroup,
    'z-field': Field,
    'z-number-keyboard': NumberKeyboard
  },
  data() {
    return {
      radio: [],
      idCard: '',
      name: '',
      cardType: '0',
      appType: getCookie('t'), //15 转转安卓，16 转转ios, 20 转转鸿蒙
      sourceCode: query.sourceCode || this.$route.query.sourceCode || '',
      result: false,
      successImg: require('./images/auth_success.png'),
      failImg: require('./images/auth_fail.png'),
      isZZ: native.in('zz'),
      isZLJ: native.in('zlj'),
      loading: false,
      showNumberKeyboard: false
    }
  },
  computed: {
    canSubmit() {
      return this.idCard && this.radio.length
    }
  },
  methods: {
    zzagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/67e371c0da1f4e0062fc0d97/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    zljagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401c5d7c955420077193c75/index.html?magicplatform=zlj&needNewWebview=1',
        needClose: '0'
      })
    },
    checkInfo() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401a9e6447e27006914ecb0/index.html?magicplatform=common&needNewWebview=1',
        needClose: '0'
      })
    },
    closePage() {
      native.close()
    },
    submit() {
      this.loading = true
      const params = {
        idCard: AESencrypt(this.idCard, '12E038D7A2B4C8F1', '0A2B38F90EC2537A'),
        sourcecode: this.sourceCode,
        decrypt: true,
        cardType: this.cardType,
        appType: this.appType
      }
      submitAuthenticationCheck(params).then((res) => {
        this.loading = false
        this.result = true
        this.isPass = res.isPass
        this.copywriting = res.copywriting
        this.buttonCtxes = res.retButtons
      }).catch((err) => {
        this.loading = false
        this.$toast(err)
      })
    },
    onInput(value) {
      if (this.idCard.length >= 18) return
      this.idCard += value
    },
    onDelete() {
      this.idCard = this.idCard.slice(0, -1);
    },
    //处理按钮
    doCommand(ctx) {
      if (ctx.cmd === 'close') {
        const isInWeChat = native.in('wechat')
        if (isInWeChat || getCookie('t') == 139) {
          // 当处于微信环境或qq下，native.close会关闭整个小程序,所以采用goback
          native.goBack()
        } else {
          native.close({ useNative: true })
        }
      } else if (ctx.cmd === 'jump') {
        native.skipToUrl({
          targetUrl: ctx.targetUrl,
          needClose: '1'
        })
      } else if (ctx.cmd == 'reverify') {
        this.result = false
      }
    },
    // 处理按钮展示逻辑
    adapterButtonCtxes(data) {
      if (!Array.isArray(data)) return []
      const buttonData = data.map((b) => {
        return {
          cmd: b.type,
          targetUrl: b.mUrl,
          text: b.buttonDesc,
          style: b.style || 'normal'
        }
      })
      return buttonData
    }
  },
  created() {
    getLastCertificationInfo().then((res) => {
      this.name = res.name
      this.cardType = res.cardType
    }).catch(() => {
      setTimeout(() => {
        native.close()
      }, 1000)
    })
  }
}
</script>

<style lang="less" scoped>
@import "index.less";
</style>